export enum EJustificationType {
    Cancellation = "Cancellation",
    Modification = "Modification",
}